import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

import artistApi from "api/artistApi";
import PostApi from "api/postApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import ModalPreview from "components/Common/ModalPreview";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import { COLOR_STATUS_POST, STATUS_POST_OPTION } from "helpers/constans";
import {
  formatDateStringToKorea,
  formatDateStringToUTC,
  formatNumberWithCommas,
} from "helpers/format";
import CountUp from "react-countup";
import { getFeedBatenders, getPosts } from "store/post/thunk";
import CollapseContent from "components/Common/CollapseContent";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import BarListDetail from "pages/BarList/BarListDetail";
import DropdownAsyncBars from "components/Common/DropdownAsyncBars";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";
import CreateEditFeedBartender from "./CreateEditFeedBartender";
import DropdownStatusNew from "components/Common/DropdownStatusNew";

interface Option {
  label: string;
  value: string;
}
export interface Tag {
  id: string;
  text: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const FeedBartenderList = (activeFeedTab: any) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const [bartenderSearch, setBartenderSearch] = useState<any | null>({
    label: t("All Filter"),
    value: "all",
  });

  const STATUS_FEED_OPTION_LANG =
    STATUS_POST_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    keyword: withDefault(StringParam, ""),
    type: withDefault(StringParam, "1"),
    user_type: withDefault(StringParam, "2"),
    status: withDefault(StringParam, ""),
    bar_id: withDefault(StringParam, ""),
    user_id: withDefault(StringParam, "") || "",
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),

    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [typeScreen, setTypeScreen] = useState<string>("feed");

  const [optionsSelected, setOptionsSelected] = useState<any>([]);
  const [isOpenConfirmStatusNews, setIsOpenConfirmStatusNews] =
    useState<boolean>(false);
  const [typeStatusNews, setTypeStatusNews] = useState<any>(null);

  const [itemToEdit, setItemToEdit] = useState<any>(false);

  const [keywordSearch, setKeywordSearch] = useState<string>(
    query["condition[title]"] || ""
  );
  const [statusSearch, setStatusSearch] = useState<any>(
    STATUS_POST_OPTION?.find((item) => item?.value === parseInt(query?.status))
      ?.value ?? ""
  );
  const [barSearch, setBarSearch] = useState<any | null>({
    label: t("All Filter"),
    value: "all",
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [start_date, end_date] = dateSearch;
  const [itemToBarDetail, setItemToBarDetail] = useState<any>(null);

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.FeedBatender;

  const PostProperties = createSelector(selectLayoutState, (state) => ({
    posts: state.posts,
    isPostLoading: state.isPostLoading,
    isPostSuccess: state.isPostSuccess,

    error: state.error,
  }));

  // Inside your component
  const { posts, isPostLoading } = useSelector(PostProperties);

  function loadTableData() {
    dispatch(getFeedBatenders(query));
  }

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  const [linkImage, setLinkImage] = useState<any>(null);
  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const searchData = () => {
    // console.log(bartenderSearch, barSearch);
    setQuery({
      ...query,
      keyword: keywordSearch || "",
      status: statusSearch,
      bar_id: barSearch?.data?.id || "",
      user_id: bartenderSearch?.data?.id || "",
      start_date: start_date
        ? formatDateStringToUTC(
            moment(new Date(start_date))
              .startOf("day")
              .format("Y-MM-DD HH:mm:ss")
          )
        : "",
      end_date: end_date
        ? formatDateStringToUTC(
            moment(new Date(end_date)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      sort_by: "created_at",
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        status: "",
        bar_id: "",
        user_id: "",
        start_date: "",
        end_date: "",
        sort_by: "created_at",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setKeywordSearch((_prev) => "");
    setStatusSearch("");
    setBarSearch({ label: t("All Filter"), value: "all" });
    setBartenderSearch({ label: t("All Filter"), value: "all" });
    setDateSearch([null, null]);
  };

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // Begin::Change status
  const [isLoadingUpdate, setIsLoadingUpdate] = useState<boolean>(false);

  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    is_active: string | boolean;
  }) => {
    try {
      if (!item) {
        return;
      }
      setIsLoadingUpdate((_prev) => true);
      const response: any = await PostApi?.updatePost(item?.id, {
        post: {
          is_active: item?.is_active,
          type: 1,
        },
      });

      setIsLoadingUpdate((_prev) => false);
      if (response?.data) {
        // setItemUpdate((_prev) => null);
        loadTableData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingUpdate((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Change status

  const handleActionStatusNews = async () => {
    if (typeStatusNews === null) {
      return;
    }

    const ids = Object.entries(optionsSelected)
      ?.reduce((arr: Option[], [key, value]: any) => {
        return [...arr, ...(value || [])];
      }, [])
      ?.map((item: Option) => item?.value);

    if (ids?.length < 1) return;

    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await PostApi?.updateStatusPost({
        articleIds: ids,
        status: typeStatusNews,
      });

      if (response?.success === true) {
        loadTableData();

        setIsConfirmLoading((_prev) => false);
        setIsOpenConfirmStatusNews(false);
        setTypeStatusNews(null);
        setOptionsSelected((_prev: any) => ({}));

        if (response?.data?.message) {
          toast(`${response?.data?.message}`, CONFIG_OPTION_TOAST_NORMAL);
        }
      } else {
        setIsConfirmLoading((_prev) => false);
        setIsOpenConfirmStatusNews(false);
        setTypeStatusNews(null);
        toast(`${response?.message}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmActionNewsClick = () => {
    setIsOpenConfirmStatusNews(false);
    setTypeStatusNews(null);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        Cell: ({ ...props }) => {
          return (
            <div>
              {posts?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Active"),
        accessor: "is_active",
        thWidth: 80,
        filterable: false,
        sortable: false,
        thClass: "text-center",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="is_active"
                id="customSwitchsizelg"
                checked={item?.is_active === 1}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({
                    id: item?.id,
                    is_active: !!value ? "1" : "0",
                  });
                }}
              />
            </div>
          );
        },
      },

      {
        Header: t("Photo"),
        accessor: "files",
        thClass: "text-center",
        filterable: true,
        sortable: false,
        thWidth: 170,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const isVideo =
            item?.files?.[0]?.full_url && item?.files?.[0]?.type === "video";
          const imgUrl = isVideo
            ? item?.files?.[0]?.preview
            : item?.files?.[0]?.full_url;
          return imgUrl ? (
            <>
              <div className="w-100 text-center " style={{ minWidth: "150px" }}>
                <div
                  style={{ width: "90px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    if (item?.files?.length > 1) {
                      setTypeScreen("feed");
                      setLinkImage({
                        urls: item?.files,
                        keyword: {
                          title: item?.title,
                          keyword: item?.description,
                        },
                      });
                    } else {
                      setLinkImage({ url: imgUrl });
                    }
                    document.body.className = "modal-open_img";
                  }}
                >
                  <img
                    src={imgUrl}
                    className="flex-shrink-0 rounded w-100"
                    alt="thumbnail"
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          );
        },
      },
      // {
      //   Header: t("Title"),
      //   accessor: "title",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: 200,
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     const isVideo = item?.files?.[0]?.url && item?.files?.[0]?.type === "video";
      //     return (
      //       <>
      //         <div className="cursor-pointer" style={{ minWidth: '200px' }}
      //           onClick={() => {
      //             setLinkImage({ url: item?.files?.[0]?.url, isVideo: isVideo, keyword: { title: item?.title, keyword: item?.description } })
      //             document.body.className = "modal-open_img";
      //           }}
      //         >{truncate(cell?.value, 70)}</div>
      //       </>
      //     );
      //   },
      // },
      {
        Header: t("Content"),
        accessor: "contents",
        filterable: true,
        sortable: false,
        thWidth: 250,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const isVideo =
            item?.files?.[0]?.url && item?.files?.[0]?.type === "video";
          return (
            <>
              <CollapseContent
                style={{ minWidth: "200px" }}
                dataOriginal={cell?.value}
                isRank={false}
                isInlineBlock={true}
                isShowModal={true}
                titleModal={t("Content")}
              />
            </>
          );
        },
      },
      {
        Header: t("Store Name"),
        accessor: "barName",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: "150",
        Cell: (cell: any) => {
          const row = cell?.row?.original;
          return (
            row?.bar?.id && (
              <>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setItemToBarDetail(row?.bar);
                    setTypeScreen("FeedToBar");
                  }}
                  style={{
                    width: "150px",
                    color: "#009ef7",
                  }}
                >
                  {row?.bar?.title}
                </div>
              </>
            )
          );
        },
      },
      {
        Header: t("Bartender"),
        accessor: "bartender",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: "150",
        Cell: (cell: any) => {
          const row = cell?.row?.original?.user_profile;
          return (
            row?.id && (
              <>
                <div
                  className="cursor-pointer"
                  style={{
                    width: "150px",
                    color: "#009ef7",
                  }}
                >
                  {row?.nickname}
                </div>
              </>
            )
          );
        },
      },
      {
        Header: t("Like"),
        accessor: "like_count",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "text-end",
        Cell: (cell: any) => {
          return (
            <>
              <div className="text-end pe-3" style={{ minWidth: "100px" }}>
                {formatNumberWithCommas(cell?.value)}
              </div>
            </>
          );
        },
      },
      {
        Header: t("View"),
        accessor: "pv",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "text-end",
        Cell: (cell: any) => {
          return (
            <>
              <div className="text-end pe-3" style={{ minWidth: "100px" }}>
                {formatNumberWithCommas(cell?.value)}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Comment"),
        accessor: "comment_count",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "text-end",
        Cell: (cell: any) => {
          return (
            <>
              <div className="text-end pe-3" style={{ minWidth: "100px" }}>
                {formatNumberWithCommas(cell?.value)}
              </div>
            </>
          );
        },
      },

      {
        Header: t("Share"),
        accessor: "share_count",
        filterable: false,
        sortable: false,
        thWidth: 100,
        thClass: "text-center",
        Cell: (cell: any) => {
          return (
            <>
              <div className="text-center" style={{ minWidth: "100px" }}>
                {formatNumberWithCommas(cell?.value)}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: 150,
        thClass: "text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end pe-3" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ width: "120px", justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`update-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-primary edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpen(true);
                      setItemToEdit(item);
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom "></i>
                  </Link>
                </li>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`delete-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-danger edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToDelete(item);
                    }}
                  >
                    <i className="ri-delete-bin-3-fill align-bottom"></i>
                  </Link>
                </li>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    [i18n?.language, posts?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  // Begin::Delete

  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await PostApi?.deletePost(id);
      if (response?.data) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // End::Delete

  const handleCloseModalBarDetail = () => {
    setItemToBarDetail(null);
  };

  useEffect(() => {
    document.title = `${t("Feed")}| Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);
  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <Row>
            <Col lg={12}>
              <div
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={posts?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <button
                        type="button"
                        className="btn btn-success d-none d-md-block"
                        onClick={() => {
                          setIsOpen(true);
                          setItemToEdit(null);
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Create Feed")}
                      </button>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-md-2 mt-0">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Content")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Content")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Store")} isShow={true}>
                          <DropdownAsyncBars
                            name="bar"
                            onChangeSelect={(event) => setBarSearch(event)}
                            isMulti={false}
                            placeholder={`${t("Select Store")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={barSearch}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2"
                      >
                        <LabelWrapper label={t("Bartender")} isShow={true}>
                          <DropdownAsyncUsers
                            name="bartender"
                            onChangeSelect={(event: any) =>
                              setBartenderSearch(event)
                            }
                            isMulti={false}
                            placeholder={`${t("Select Bartender")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={bartenderSearch}
                            isClearable={false}
                            defaultParams={{ is_active: 1 }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_FEED_OPTION_LANG || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(event: any) => {
                              setStatusSearch(event?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_POST}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-xl-2 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!start_date || !!end_date}
                        >
                          <DatePickerCustom
                            startDate={start_date || null}
                            endDate={end_date || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={9}
                        xl={9}
                        xxl={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                            disabled={isPostLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-success mb-2 me-3 mb-sm-0"
                            onClick={(e) => {
                              e.preventDefault();
                              handleActiveDisableNews("activated");
                            }}
                            disabled={isConfirmLoading || countRowSelected <= 0}
                          >
                            {countRowSelected > 0 && (
                              <span
                                className="position-absolute topbar-badge badge rounded-pill bg-danger"
                                style={{ transform: "translate(0%, -70%)" }}
                              >
                                {formatNumberWithCommas(countRowSelected)}
                                <span className="visually-hidden">
                                  total keywords selected
                                </span>
                              </span>
                            )}
                            <i className="ri-checkbox-circle-line align-bottom me-1"></i>{" "}
                            {t("Active")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary  mb-2 mb-sm-0"
                            onClick={(e) => {
                              e.preventDefault();
                              handleActiveDisableNews("disabled");
                            }}
                            disabled={isConfirmLoading || countRowSelected <= 0}
                          >
                            {countRowSelected > 0 && (
                              <span
                                className="position-absolute topbar-badge badge rounded-pill bg-danger"
                                style={{ transform: "translate(0%, -70%)" }}
                              >
                                {formatNumberWithCommas(countRowSelected)}
                                <span className="visually-hidden">
                                  total keywords selected
                                </span>
                              </span>
                            )}
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Disable")}
                          </button>
                        </div>
                      </Col> */}
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-feed-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={posts?.list?.length ? posts?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={posts?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(posts?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isPostLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </div>
            </Col>
          </Row>
        </Container>
        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Post")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        {isOpen && (
          <CreateEditFeedBartender
            setIsOpen={setIsOpen}
            item={itemToEdit}
            setItemToEdit={setItemToEdit}
            loadTableData={loadTableData}
            linkImage={linkImage}
            setLinkImage={setLinkImage}
            onCloseImageClick={onCloseImageClick}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
          typeScreen={typeScreen}
        />

        <ModalConfirm
          textButtonConfirm={
            typeStatusNews === "activated" ? t("Active") : t("Disable")
          }
          classButtonConfirm="btn-soft-primary"
          classIconButtonConfirm={
            typeStatusNews === "activated"
              ? "ri-checkbox-circle-line"
              : "ri-refresh-line"
          }
          header={typeStatusNews === "activated" ? t("Active") : t("Disable")}
          title={
            typeStatusNews === "activated"
              ? t("Do you want to active all the items!")
              : t("Do you want to disable all the items!")
          }
          content={""}
          isShowIcon={false}
          isOpen={isOpenConfirmStatusNews}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmActionNewsClick}
          onConfirm={handleActionStatusNews}
        />

        {/* <ModalConfirm
          textButtonConfirm={t('Button Update')}
          classButtonConfirm='btn-primary'
          classIconButtonConfirm=''
          header={(String(itemUpdate?.status) === ENUM_STATUS_FEED.ACTIVATED) ? t('Confirm to ON') : t('Confirm to OFF')}
          title={t('Are you sure you want to update this?')}
          content={t('After confirming the update action, the data will be updated. Do you want to proceed with the update action.')}
          isShowIcon={false}
          isOpen={!!itemUpdate}
          isLoading={isLoadingUpdate}
          onClose={() => setItemUpdate((prev: any) => null)}
          onConfirm={handleOnConfirmUpdate}
        /> */}

        {itemToBarDetail && (
          <Modal
            isOpen={!!itemToBarDetail}
            centered={true}
            size="xl"
            className="modal-fullscreen"
            scrollable={false}
          >
            <ModalHeader toggle={handleCloseModalBarDetail}>
              {itemToBarDetail?.title || ""}
            </ModalHeader>
            <ModalBody>
              <BarListDetail
                barID={itemToBarDetail?.id}
                setLinkImage={setLinkImage}
                // isShowDetail={true}
              />
            </ModalBody>
          </Modal>
        )}
      </div>
    </React.Fragment>
  );
};

export default FeedBartenderList;
